import {
  MOBILE_MAIN_PATTERN,
  MOBILE_DETAILS_PATTERN,
  TABLET_PATTERN,
} from "./constants";
import { DeviceType, DeviceInfo } from "./types";

const isTabletDevice = (device: DeviceInfo) =>
  new RegExp(TABLET_PATTERN, "i").test(device);

const isMobileDevice = (device: DeviceInfo) =>
  new RegExp(MOBILE_MAIN_PATTERN, "i").test(device) ||
  new RegExp(MOBILE_DETAILS_PATTERN, "i").test(
    device.substring(0, 4) // e.g. "Mozilla/5.0..." => "Mozi"
  );

export const checkDeviceType = () => {
  const deviceInfo = navigator.userAgent || navigator.vendor;

  const deviceType: DeviceType = {
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  };

  if (isTabletDevice(deviceInfo)) {
    deviceType.isTablet = true;
  } else if (isMobileDevice(deviceInfo)) {
    deviceType.isMobile = true;
  } else {
    deviceType.isDesktop = true;
  }

  return deviceType;
};
